import { SpaceActionType } from '../../types';
import React from 'react';
import { SaveAndShareModal, SaveAndShareModalProps } from '../../components/SaveAndShareModal';
import { useDefaultSpaceSelectOption, useSpacesEnabled } from '../../hooks';

export interface SaveAndShareModalContainerProps
  extends Omit<SaveAndShareModalProps, 'mode' | 'disableSpaceSelect'> {}

export const SaveAndShareModalContainer: React.FC<SaveAndShareModalContainerProps> = ({
  open,
  objectType,
  spaceOptions,
  selectedSpace,
  onSpaceSelect,
  ...rest
}) => {
  const { hasSpacesFeaturePack } = useSpacesEnabled();
  const mode: SpaceActionType = 'add';
  const saveAndShareModalProps = { ...rest, mode };
  useDefaultSpaceSelectOption(
    open,
    objectType,
    '',
    selectedSpace,
    spaceOptions,
    onSpaceSelect,
    'add',
  );

  return (
    <SaveAndShareModal
      open={open}
      objectType={objectType}
      spaceOptions={spaceOptions}
      selectedSpace={selectedSpace}
      onSpaceSelect={onSpaceSelect}
      disableSpaceSelect={!hasSpacesFeaturePack}
      {...saveAndShareModalProps}
    />
  );
};
